import {
  useAppDispatch,
  useAppSelector,
} from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { getHeader } from "./header.thunk";
import { resetHeader } from "./header.slice";
import { isError, isIdle, isLoading, isSuccess } from "@/app/utils/asyncStatus";

const useHeader = () => {
  const dispatch = useAppDispatch();
  const { data: header, error: headerError, status: headerStatus } = useAppSelector(
    (store) => store.header,
  );

  const fetchHeader = useCallback(() => {
    dispatch(getHeader());
  }, [dispatch]);

  const clearHeader = useCallback(() => {
    dispatch(resetHeader());
  }, [dispatch]);

  return {
    header,
    headerError,
    headerStatus,
    isIdle: isIdle(headerStatus),
    isLoading: isLoading(headerStatus),
    isSuccess: isSuccess(headerStatus),
    isError: isError(headerStatus),
    fetchHeader,
    clearHeader,
  };
};

export default useHeader;